module.exports = __webpack_public_path__ + "23180425b253e694c377b6e697e52b06.svg";